import React, { useEffect } from "react";

import { TextField } from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

import { useForm } from "react-hook-form";
import ButtonWithStyle from "../../../HOCs/ButtonWithStyle/ButtonWithStyle";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { connect } from "react-redux";
import { syncLoyaltyRewards, AddRewardToLevel, getLoyaltyRewardsPerLevel } from "../../../actions/loyalty";

const schema = yup.object().shape({
	reward: yup.string().required(),
	amount: yup.number().moreThan(0).integer().required(),
});

const LevelRewards = ({ rewards, cancelSubmit, syncRewards, level, AddRewardToLevel, updateRewards }) => {
	const { register, handleSubmit } = useForm({ resolver: yupResolver(schema) });
	const submit = ({ reward: id, amount }) => {
		if (!window.confirm("Desea agregar al nivel actual?")) return;
		const newReward = {
			amount,
			item: rewards.find((reward) => reward._id === id),
		};
		AddRewardToLevel({ reward: newReward, level }, updateRewards);
		cancelSubmit();
	};

	useEffect(() => {
		if (rewards.length < 1) syncRewards();
	}, [syncRewards, rewards]);

	return (
		<form>
			<TextField
				style={{ width: "200px", margin: "1em 0" }}
				select
				SelectProps={{
					native: true,
					IconComponent: () => <ArrowDropDownIcon />,
				}}
				name="reward"
				inputRef={register({ required: true, minLength: 2 })}
			>
				{rewards.map((reward) => (
					<option key={reward._id} value={reward._id}>
						{reward.name}
					</option>
				))}
			</TextField>
			<TextField
				style={{ width: "200px", margin: "1em 0" }}
				name="amount"
				label="Cantidad"
				inputRef={register({ required: true })}
			/>
			<br />
			<ButtonWithStyle style={{ backgroundColor: "gray", margin: 0 }} onClick={cancelSubmit}>
				Cancelar
			</ButtonWithStyle>
			<ButtonWithStyle style={{ margin: "0 0 0 5px" }} onClick={handleSubmit(submit)}>
				Guardar
			</ButtonWithStyle>
		</form>
	);
};

const mapStateToProps = ({ loyalty }) => {
	return { rewards: loyalty.rewards };
};

const actions = {
	syncRewards: syncLoyaltyRewards,
	AddRewardToLevel,
	updateRewards: getLoyaltyRewardsPerLevel,
};
export default connect(mapStateToProps, actions)(LevelRewards);
